<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    button_title1: {
      type: String,
      required: false,
    },
    button_title2: {
      type: String,
      required: false,
    },
    button_title3: {
      type: String,
      required: false,
    },
    button_title4: {
      type: String,
      required: false,
    },
    button_title5: {
      type: String,
      required: false,
    },
    button_title6: {
      type: String,
      required: false,
    },
    button_title7: {
      type: String,
      required: false,
    },
    button_hidden1: {
      type: Boolean,
      required: false,
    },
    button_hidden2: {
      type: Boolean,
      required: false,
    },
    button_hidden3: {
      type: Boolean,
      required: false,
    },
    button_hidden4: {
      type: Boolean,
      required: false,
    },
    button_hidden5: {
      type: Boolean,
      required: false,
    },
    button_hidden6: {
      type: Boolean,
      required: false,
    },
    button_hidden7: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {}
  },
  created() {
    //ボタンタイトルの文字数の拡張に伴い縦幅を調整（広域ページ移行STEP2）
    //これに伴い、ポップアップ選択ボタンのサイズを66.4ptに統一したため、リサイズ機能を削除
    // window.addEventListener('resize', this.handleResize)
    // this.handleResize()
  },
  methods: {
    openBarcode(flag) {
      this.$emit('open', flag)
    },
    cancelHandler() {
      this.$emit('cancel')
    },
    //ボタンタイトルの文字数の拡張に伴い縦幅を調整（広域ページ移行STEP2）
    //これに伴い、ポップアップ選択ボタンのサイズを66.4ptに統一したため、リサイズ機能を削除
    // handleResize() {
    //     if (window.innerWidth >= 2048) {
    //       $('.button_title').css('height', '60px')
    //     }
    //     else if (window.innerWidth >= 1920) {
    //       $('.button_title').css('height', '50px')
    //     }
    //     else if (window.innerWidth >= 1707) {
    //       $('.button_title').css('height', '40px')
    //     }
    //     else if (window.innerWidth > 1536) {
    //       $('.button_title').css('height', '37px')
    //     }
    //     else {
    //       $('.button_title').css('height', '33.2px')
    //     }
    // },
  },
}
</script>

<template>
  <div id="modals">
    <transition class="modal">
      <div
        v-if="show === true"
        id="modal_back_cover"
        @click.self="cancelHandler"
      >
        <div :class="$style.modal_set" style="min-height: 0;">
          <button :class="$style.cancel_btn" @click="$emit('cancel')"><span aria-hidden="true"><img src="@img/icon_72_close.png"></span></button>
          <div :class="$style.modal_contents">
            <div :class="$style.modal_inner">
              <div :class="$style.subject">
                <button v-show="!button_hidden1" class="popup_button1" @click="openBarcode(1)">{{button_title1}}</button>
                <button v-show="!button_hidden2" class="popup_button2" @click="openBarcode(2)">{{button_title2}}</button>
                <button v-show="!button_hidden3" class="popup_button3" @click="openBarcode(3)">{{button_title3}}</button>
                <button v-show="!button_hidden4" class="popup_button4" @click="openBarcode(4)">{{button_title4}}</button>
                <button v-show="!button_hidden5" class="popup_button5" @click="openBarcode(5)">{{button_title5}}</button>
                <button v-show="!button_hidden6" class="popup_button6" @click="openBarcode(6)">{{button_title6}}</button>
                <button v-show="!button_hidden7" class="popup_button7" @click="openBarcode(7)">{{button_title7}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" module>
// @import '~@assets/css/brand-list.scss';
@media screen and (max-width: 560px) {
  .modal_set {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 89.3%;
    max-height: 80%;
    min-height: 30%;

    transform: translate(-50%, -50%);

    background-color: #ffffff;
    border-radius: 14px;
    overflow: auto;
  }
  .modal_set .cancel_btn {
    position: absolute;
    width: 25px;
    opacity: 1;
    right: 7px;
    top: 7px;
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    z-index: 1;
  }
  .modal_set span img {
    width: 25px;
  }
  .modal_contents .modal_inner {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 40px 40px;
    overflow: auto;
  }
  .modal_contents .modal_inner .subject {
    text-align: center;
    font-size: 36px;
    line-height: 38px;
    font-weight: bold;
    color: #4a4a4a;
    padding: 60px 0;
    // border-bottom: 2px solid #dddddd;
  }
  .modal_contents .modal_inner .subject button {
    width: 95%;
    height:52px;
    background-color:#ffb932;
    border:solid 2px #ffb932;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    font-size:16px;
    margin: 0px 0px 16px 0px;
  }

  @media screen and (max-width: 560px) {
    .modal_contents .modal_inner {
      padding: 20px 20px;
    }
    .modal_contents .modal_inner .subject {
      font-size: 14px;
      line-height: 16px;
      padding: 14px;
    }
  }
}

@media screen and (min-width: 560px) {
  .modal_set {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 40%;
    max-height: 80%;
    min-height: 30%;

    transform: translate(-50%, -50%);

    background-color: #ffffff;
    border-radius: 14px;
    overflow: auto;
  }
  .modal_set .cancel_btn {
    position: absolute;
    width: 25px;
    opacity: 1;
    right: 7px;
    top: 7px;
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    z-index: 1;
  }
   .modal_set span img {
    width: 25px;
  }
  .modal_contents .modal_inner {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 40px 40px;
    overflow: auto;
  }
  .modal_contents .modal_inner .subject {
    text-align: center;
    font-size: 36px;
    line-height: 38px;
    font-weight: bold;
    color: #4a4a4a;
    padding: 60px 0;
    // border-bottom: 2px solid #dddddd;
  }
  .modal_contents .modal_inner .subject button {
    width: 95%;
    height:52px;
    background-color:#ffb932;
    border:solid 2px #ffb932;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    font-size:18px;
    margin: 0px 0px 16px 0px;
  }
}
</style>
